import React from "react";
import "./style.css";
import logo from "../../../assets/logo/avitech_logo_colored.png";
import LinkedInIcon from "react-icons/lib/ti/social-linkedin";
import TwitterIcon from "react-icons/lib/ti/social-twitter";
import InstagramIcon from "react-icons/lib/ti/social-instagram";
import { Typography } from "../../../views/products/partials";

const styles = {
  listHeader: {
    textTransform: "uppercase",
    fontSize: "12px",
  },
  listItem: {
    fontSize: "10px",
  },
  divider: {
    borderColor: "#ebebeb",
    // borderColor: '#2295549e'
  },
  border: { borderTop: "1px solid #ebebeb" },
};

const Footer = () => (
  <div className="footer">
    <div className="container">
      <div className="row" style={styles.border}>
        <div className="col-md-5">
          <div className="logo-cover">
            <img src={logo} alt="" className="logo" />
            <p className="mt-2">
              42 Local Airport Road, <br />
              Ikeja, Lagos.
              <br />
              info@avitech.com
            </p>
          </div>
        </div>
        <div className="col-md-2">
          <br />
          <br />
          <h5 className="text-danger" style={styles.listHeader}>
            Navigation
          </h5>
          <ul>
            <li style={styles.listItem}>
              <a href="/" target="_blank">
                Home
              </a>
            </li>
            <li style={styles.listItem}>
              <a href="/about" target="_blank">
                About
              </a>
            </li>
            <li style={styles.listItem}>
              <a href="">Blog</a>
            </li>
            <li style={styles.listItem}>
              <a href="/products" target="_blank">
                Resources
              </a>
            </li>
            <li style={styles.listItem}>
              <a href="/contact-us" target="_blank">
                Contact Us
              </a>
            </li>
            <li style={styles.listItem}>
              <a href="/privacy-policy" target="_blank">
                Privacy policy
              </a>
            </li>
            <li style={styles.listItem}>
              <a href="/cookie-policy" target="_blank">
                Cookie policy
              </a>
            </li>
            <li style={styles.listItem}>
              <a href="/customer-awareness-policy" target="_blank">
                Customer awarenss policy
              </a>
            </li>
          </ul>
        </div>
        <div className="col-md-2">
          <br />
          <br />
          <h5 className="text-danger" style={styles.listHeader}>
            Products
          </h5>
          <ul>
            <li style={styles.listItem}>
              <a href="">AviCollect</a>
            </li>
            <li style={styles.listItem}>
              <a href="">Cargo</a>
            </li>
            <li style={styles.listItem}>
              <a href="http://bda.avipayng.com">BDA</a>
            </li>
            <li style={styles.listItem}>
              <a href="">Toll</a>
            </li>
          </ul>
        </div>
        <div className="col-md-3">
          <br />
          <br />
          <h5 className="text-danger" style={styles.listHeader}>
            Social Media
          </h5>
          <ul>
            <li style={styles.listItem}>
              <a href="">
                <LinkedInIcon color="#212121" size="20" />
                &nbsp;&nbsp;LinkedIn
              </a>
            </li>
            <li style={styles.listItem}>
              <a href="">
                <TwitterIcon color="#212121" size="20" />
                &nbsp;&nbsp;Twitter
              </a>
            </li>
            <li style={styles.listItem}>
              <a href="">
                <InstagramIcon color="#212121" size="20" />
                &nbsp;&nbsp;Instagram
              </a>
            </li>
          </ul>
        </div>
        <div className="col-md-12">
          <hr style={styles.divider} />
          <Typography variant="hint" align="center" color="#212121">
            <span className="copyright">{`${new Date().getFullYear()} AviTech Software Solutions. All Rights Reserved`}</span>
          </Typography>
        </div>
      </div>
    </div>
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/shared/components/footer/index.js